import * as React from 'react'

import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { faChevronLeftSolid, faChevronRightSolid, FaIcon } from '@/lib/fa'

interface Props {
  value: string | null
  onConfirm: (newValue: string) => void
  confirmSelection?: boolean
}

const YearPicker: React.FC<Props> = ({
  value,
  onConfirm,
  confirmSelection = false,
}) => {
  const { t } = useLocalize()
  const currentYear = new Date().getFullYear()
  const initialYear = value ? parseInt(value, 10) : currentYear

  const [startYear, setStartYear] = React.useState(initialYear - 5)
  const [selectedYear, setSelectedYear] = React.useState(initialYear)

  const handlePrevRange = () => setStartYear((prev) => prev - 12)
  const handleNextRange = () => setStartYear((prev) => prev + 12)
  const handleSelectYear = (y: number) => {
    ;(setSelectedYear(y), confirmSelection ? null : onConfirm(y.toString()))
  }

  const handleConfirm = () => {
    onConfirm(selectedYear.toString())
  }

  const years = Array.from({ length: 12 }, (_, i) => startYear + i)

  return (
    <div className="tw-h-fit tw-w-fit tw-rounded-lg tw-bg-white tw-shadow-md">
      <div className="tw-w-[340px]">
        <div className="tw-flex tw-items-center tw-justify-between tw-p-4">
          <FaIcon
            icon={faChevronLeftSolid}
            className="tw-w-5 tw-cursor-pointer hover:tw-opacity-90"
            onClick={handlePrevRange}
          />
          <p className="tw-font-semibold">
            {years[0]} – {years[years.length - 1]}
          </p>
          <FaIcon
            icon={faChevronRightSolid}
            className="tw-w-5 tw-cursor-pointer hover:tw-opacity-90"
            onClick={handleNextRange}
          />
        </div>

        <div className="tw-grid tw-grid-cols-4 tw-gap-2 tw-px-4 tw-pb-4">
          {years.map((y) => (
            <div
              key={y}
              onClick={() => handleSelectYear(y)}
              className={`tw-w-full tw-cursor-pointer tw-rounded tw-border-2 tw-border-transparent tw-py-4 tw-text-center tw-font-normal ${
                selectedYear === y
                  ? '!tw-border-primary tw-bg-secondary tw-font-semibold tw-text-primary'
                  : 'tw-bg-transparent tw-text-content-base/90'
              } hover:tw-bg-secondary hover:tw-font-semibold`}
            >
              {y}
            </div>
          ))}
        </div>
        {confirmSelection && (
          <div className="tw-flex tw-justify-end tw-p-3">
            <button
              onClick={handleConfirm}
              className="tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-90"
            >
              {t('common.confirm')}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default YearPicker
